import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/creature.webp'
import _imports_1 from '../public/sounds/sound.mp3'


const _hoisted_1 = {
  key: 0,
  class: "popup"
}
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "main__ca-section" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "initial__title" }

import {ref} from "vue";
import copyIcon from '@/assets/icons/copy.svg'
import checkIcon from '@/assets/icons/check.svg'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isPopupOpen = ref<boolean>(true)
const currentIcon = ref(copyIcon)
const musicAudio = ref<HTMLElement | null>(null)
const initial = ref<HTMLElement | null>(null)
const isAnimating = ref(false);

const firstLine = "SCARIEST".split("");
const secondLine = "STORIES".split("");

const copyTextToClipboard = async (copyText: string): Promise<void> => {
  if (!navigator.clipboard) return;
  try {
    await navigator.clipboard.writeText(copyText)
    currentIcon.value = checkIcon
  } catch (e) {
    console.log(e);
  } finally {
    setTimeout(() => {
      currentIcon.value = copyIcon
    }, 3000)
  }
};
const restartAnimation = () => {
  isAnimating.value = false;
  setTimeout(() => {
    isAnimating.value = true;
  }, 0);
};
const playMusic = () => {
  if (musicAudio.value instanceof HTMLAudioElement) {
    musicAudio.value.play()
  }
}
const closePopup = () => {
  isPopupOpen.value = false
  restartAnimation()
  playMusic()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "popup" }, {
      default: _withCtx(() => [
        (isPopupOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", { class: "popup__wrapper" }, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "popup__text" }, "Try not to get scared", -1)),
                _createElementVNode("div", {
                  class: "popup__ok",
                  onClick: closePopup
                }, "OK")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("main", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "main__header" }, "$scary", -1)),
      _createElementVNode("div", {
        class: "main__container",
        onClick: restartAnimation
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("h2", { class: "main__title" }, "Try not to get scared", -1),
        _createElementVNode("img", {
          class: "main__image",
          src: _imports_0,
          alt: "creature"
        }, null, -1)
      ])),
      _cache[5] || (_cache[5] = _createElementVNode("a", {
        href: "https://knowyourmeme.com/memes/try-not-to-get-scared-scariest-stories",
        target: "_blank"
      }, [
        _createElementVNode("div", { class: "main__lore" }, "SCARY LORE")
      ], -1)),
      _createElementVNode("span", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "main__ca" }, " ca: ADQeyKAWoLDVnE6Vajnwp9h7wVdzNFosPqQvmEB3pump ", -1)),
        _createElementVNode("img", {
          class: "main__copy",
          src: currentIcon.value,
          alt: "copy-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (copyTextToClipboard('ADQeyKAWoLDVnE6Vajnwp9h7wVdzNFosPqQvmEB3pump')))
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["initial", {'initial--animated' : isAnimating.value}]),
      ref_key: "initial",
      ref: initial
    }, [
      _createElementVNode("span", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(firstLine), (letter, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: index,
            class: _normalizeClass(["initial__letter", {'initial__letter--animated' : isAnimating.value}]),
            style: _normalizeStyle({ animationDelay: `${Math.random() * 0.5}s` })
          }, _toDisplayString(letter), 7))
        }), 128)),
        _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(secondLine), (letter, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: `second-${index}`,
            class: _normalizeClass(["initial__letter", {'initial__letter--animated' : isAnimating.value}]),
            style: _normalizeStyle({ animationDelay: `${Math.random() * 0.5}s` })
          }, _toDisplayString(letter), 7))
        }), 128))
      ])
    ], 2),
    _cache[8] || (_cache[8] = _createStaticVNode("<a href=\"https://x.com/ScaryStoriesSol\" target=\"_blank\"><span class=\"links__twitter links__link\"> Twitter </span></a><a href=\"https://t.me/ScariestStoriesCTO\" target=\"_blank\"><span class=\"links__telegram links__link\"> Telegram </span></a><a href=\"https://dexscreener.com/solana/j2f4ijsmu1rnds9xusw2jb1vm7j64k91cpepwqf7uark\" target=\"_blank\"><span class=\"links__dexscreener links__link\"> DexScreener </span></a><a href=\"https://www.tiktok.com/@offlainnnn?_t=8s8PhS63Tq2&amp;_r=1\" target=\"_blank\"><span class=\"links__tiktok links__link\"> TikTok </span></a>", 4)),
    _createElementVNode("audio", {
      ref_key: "musicAudio",
      ref: musicAudio
    }, _cache[7] || (_cache[7] = [
      _createElementVNode("source", { src: _imports_1 }, null, -1)
    ]), 512)
  ], 64))
}
}

})